import { Component, OnInit,ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { PositionService} from '../services/position.service';
import { DeviceService } from '../services/device.service';
import { UserService } from '../services/user.service';
import { Message } from 'primeng/primeng';
import { AddressService } from '../services/address.service';
import { Table } from 'primeng/components/table/table';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-leisure-report',
  templateUrl: './leisure-report.component.html',
  styleUrls: ['./leisure-report.component.css']
})
export class LeisureReportComponent implements OnInit {
  fileName:String;
  duration: number;
  displayLocation: boolean=false;
  options: any;
  overlays: any[];
  position:any;
  totalRecords: number;
  positions : any [];
  devices: SelectItem[];
  dateOptions: SelectItem[];
  dateOption: any;
  idDevice: String;
  disabledInitialDate: boolean;
  disabledFinalDate: boolean;
  initialDate: Date;
  finalDate: Date;
  msgs: Message[] = [];
  blockedDocument: boolean = false;
  cols: any[];
  totalLeisure :number;
  maxDays:number=10;

  @ViewChild('dt') table: Table;

  constructor(private positionService:PositionService,private deviceService : DeviceService,
    private userService: UserService, private addressService:AddressService) { }

    ngOnInit() {
      this.cols = [
              { field: 'nameDevice', header: 'NOMBRE' },
              { field: 'from', header: 'DESDE' },
              { field: 'to', header: 'HASTA' },
              { field: 'duration', header: 'DURACION (h:m:s)' },
              { field: 'latLng', header: 'POSICION' },
              { field: 'address', header: 'DIRECCION' }
          ];
      this.dateOptions = [
        {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
        {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
        {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
        {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
      ];

      this.devices = [];
      this.deviceService.findByUserBranch(this.userService.userLoged.idUser).then(data => {
        let response: any = data;
        response.devices.forEach(item => {
          this.devices.push({label: item.name, value: item.idDevice});
        });
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      });
      this.duration = 5;
      this.dateOption = '7';
      this.changeDate();
    }

    changeDate(){
      this.disabledInitialDate = true;
      this.disabledFinalDate = true;
      if(this.dateOption == 'T'){
        this.initialDate = new Date();
        this.finalDate = new Date();
        this.initialDate.setHours(0,0,0);
        this.finalDate.setHours(23,59,59);
      }else if(this.dateOption == 'Y'){
        this.initialDate = new Date();
        this.finalDate = new Date();
        this.initialDate.setDate(this.initialDate.getDate() - 1);
        this.initialDate.setHours(0,0,0);
        this.finalDate.setDate(this.finalDate.getDate() - 1);
        this.finalDate.setHours(23,59,59);
      }else if(this.dateOption == '7'){
        this.initialDate = new Date();
        this.finalDate = new Date();
        this.initialDate.setDate(this.initialDate.getDate() - 6);
        this.initialDate.setHours(0,0,0);
        this.finalDate.setHours(23,59,59);
      }else{
        this.disabledInitialDate = false;
        this.disabledFinalDate = false;
      }
    }

    diferenciaEntreFechasEnDias(a:Date, b:Date):number{
      return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
    }

    buscar(){
      if(this.table){
        this.table.first=1;
      }

      this.fileName="Reporte_de_Ocio_";
      this.devices.forEach(item =>{
        if(item.value == this.idDevice){
          this.fileName = this.fileName+item.label;
        }
      });
      if(this.diferenciaEntreFechasEnDias(this.initialDate,this.finalDate) > this.maxDays){
        this.msgs = [{severity:'error', summary:'ERROR', detail:"El rango de fechas no debe exceder los "+this.maxDays+" dias"}];
        return;
      }
      if(this.initialDate >= this.finalDate){
        this.msgs = [{severity:'error', summary:'ERROR', detail:"La fecha final debe ser superior a la fecha inicial"}];
        return;
      }
      this.blockedDocument = true;
      this.positions = [];
      this.positionService.findByLeisure(this.idDevice,this.initialDate,this.finalDate,this.duration).then(data => {
        let response: any = data;
        this.totalLeisure = 0;
        response.positions.forEach(item => {
          //if(item.time >= this.duration*1000*60){
            this.totalLeisure = this.totalLeisure + item.time;
            item.latitude = item.latitude.toFixed(6);
            item.longitude = item.longitude.toFixed(6);
            item.latLng = item.latitude+", "+item.longitude
            this.positions.push(item);
        //  }
        });
        this.totalRecords = this.positions.length;
        this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
      });

    }

    formatTime(time:number):String{
      let hours =  Math.floor(time / 3600000);
      let minutes = Math.floor(((time/1000) - (+hours * 3600))/60);
      let seconds = (time/1000) - (+hours * 3600) - (+minutes * 60);
      return this.pad(hours,2) + ":" + this.pad(minutes,2) + ":" + this.pad(seconds,2);
    }

    pad(num:number, size:number): string {
      let s = num+"";
      while (s.length < size) s = "0" + s;
      return s;
    }

    showInMap(position:any){
      this.overlays = [];
      this.displayLocation = true;
      let latLng = new google.maps.LatLng(position.latitude, position.longitude);
      this.options = {
        zoom: 13,
        center:latLng
      };
      let marker = new google.maps.Marker({position: latLng});
      this.position = position;
      this.overlays.push(marker);
    }

    hide(){
      this.displayLocation = false;
    }

    getAddress(position:any){
      this.blockedDocument = true;
      this.addressService.findAddressByCoordinates(position).then(data =>{
        let response: any = data;
          if(response.status == 'OK'){
            position.address = response.address;
            this.msgs = [{severity:'info', summary:'INFO', detail:'Dirección obtenida Exitosamente'}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
          this.blockedDocument = false;
      });;
    }

    exportXLS(){
      let records = [];
      this.positions.forEach(item=>{
        let data = {};
        this.cols.forEach(col => {
          data[col.header] = item[col.field];
        });
        records.push(data);
      });

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
      const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
      XLSX.writeFile(workbook, this.fileName+".xlsx");
    }
}



// WEBPACK FOOTER //
// ./src/app/leisure-report/leisure-report.component.ts